import { render, staticRenderFns } from "./ExibirErros.vue?vue&type=template&id=8ad8deb6&"
import script from "./ExibirErros.vue?vue&type=script&lang=js&"
export * from "./ExibirErros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports